// Obfuscated Pollinations public API key — XOR'd with project name
// This is a rate-limit key, not a secret. Obfuscated to avoid casual scraping.
const _m = [20,25,58,66,93,43,87,5,51,58,81,35,55,62,6,52,43,15,32];
const _s = "drevil";
let _cached: string | null = null;

/** Returns the Pollinations API key (decoded once, cached). */
export function getApiKey(): string {
  if (!_cached) {
    _cached = _m.map((c, i) => String.fromCharCode(c ^ _s.charCodeAt(i % _s.length))).join("");
  }
  return _cached;
}
